import emitter from '../../mixin/emitter'

export default {
  name: 'UiFormRadio',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  model: {
    prop: 'modelValue',
    event: 'input',
  },

  // language=HTML
  template: `
    <div 
      :class="[
        'form-check',
        { 
          'form-check-inline': inline,
          'is-disabled': disabled,
        }
      ]"
      :title="title"
    >
      <slot name="prepend"></slot>
      <component :is="labelTag" class="form-check-label">
        <input
          v-bind="$attrs"
          class="form-check-input"
          type="radio"
          :disabled="disabled"
          :value="radioValue"
          :checked="isChecked"
          @change="handleChange"
        />
        <slot></slot>
        <template v-if="!$slots.default">{{ label }}</template>
      </component>
      <slot name="append"></slot>
    </div>
  `,

  props: {
    disabled: Boolean,
    modelValue: {},
    value: {},
    labelTag: {
      type: String,
      default: 'label',
    },
    label: {},
    title: {
      type: String,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    radioValue() {
      if (this.value !== undefined) {
        return this.value
      }
      return this.label
    },

    isChecked() {
      return this.modelValue === this.radioValue
    },
  },

  methods: {
    handleChange() {
      this.$emit('input', this.radioValue)
      this.dispatch('UiFormItem', 'ui.form.change', this.radioValue)
      this.$emit('change', this.radioValue)
    },
  },
}
